export default __webpack_public_path__ + "static/media/spam.63a1e0b1.png";